import { NavigationGuard } from 'vue-router';

import { getOrderPathForSlug, OrderStep } from '@/constants/order/constants';
import { orderActions, orderGetters } from '@/store/modules/order';

export const checkCustomizationStep: NavigationGuard = async (to, from, next) => {
	let { orderGuid } = to.params;

	if (!orderGuid) {
		return next();
	}

	if (Array.isArray(orderGuid)) {
		orderGuid = orderGuid[0];
	}

	if (orderGuid && !orderGetters.getOrderByGuid()(orderGuid)) {
		await orderActions.fetchOrderByGuid(orderGuid);
	}

	const order = orderGetters.getOrderByGuid()(orderGuid);
	const orderSteps = Object.values(OrderStep);

	if (!order || !orderSteps.includes(to?.name as any)) {
		return next();
	}

	if (order.terminal_device_only || to.name == OrderStep.Files) {
		return next();
	}

	const path = getOrderPathForSlug(order.prosthesis.slug);

	if (!path) {
		console.error(`Order path not defined for prosthesis slug: ${order.prosthesis.slug}`, {
			order_id: order.id,
			prosthesis_name: order.prosthesis.name,
			prosthesis_slug: order.prosthesis.slug,
		});
		return next('404');
	}

	if (!path.includes(to.name as OrderStep)) {
		return next('404');
	}

	return next();
};
